export default "<div class=\"container\">\n  <hr />\n  <p>For internal use only |\n    &copy 2016 <a href=\"#\">Lemon Leaf</a>\n  </p>\n</div>\n";